export default "__VITE_ASSET__xFWVx$sA__"